/**
 * groupBy function is a generalised method to group array of objects on the basis of particular property.
 * @param list This is the Array
 * @param property We are grouping the array based on property provides
 * @returns It will return object based on property from an array of objects
 */
export function groupBy<T>(list: T[], fn: (item: T) => any): Object {
  return list.reduce<Record<string, T[]>>((prev, curr) => {
    const groupKey = fn(curr);
    const group = prev[groupKey] || [];
    group.push(curr);
    return { ...prev, [groupKey]: group };
  }, {});
}
